import { VStack, Heading, Text, Box, HStack, Input, Button } from '@chakra-ui/react'
import { UserCircle, Lock } from 'lucide-react'
import { useAuth } from '@/features/auth/hooks/useAuth'
import { Field } from '@/components/ui/field'

export function ProfilePage() {
  const { data: auth } = useAuth()
  const user = auth?.session?.user

  return (
    <VStack align="stretch" gap={6}>
      {/* Header */}
      <VStack align="start" gap={2}>
        <HStack gap={2}>
          <UserCircle size={24} />
          <Heading as="h2" fontSize="2xl">
            Mon compte
          </Heading>
        </HStack>
        <Text color="gray.600">
          Gérez vos informations personnelles et votre sécurité
        </Text>
      </VStack>

      {/* Personal Information */}
      <VStack align="stretch" gap={4}>
        <Heading as="h3" fontSize="lg">
          Informations personnelles
        </Heading>

        <Box
          p={6}
          bg="white"
          borderRadius="lg"
          border="1px solid"
          borderColor="gray.200"
        >
          <VStack align="stretch" gap={4}>
            <Field label="Email">
              <Input
                type="email"
                value={user?.email || ''}
                disabled
                bg="gray.50"
              />
            </Field>

            <Field label="Prénom">
              <Input
                type="text"
                defaultValue={user?.user_metadata?.first_name || ''}
                placeholder="Votre prénom"
              />
            </Field>

            <Field label="Nom">
              <Input
                type="text"
                defaultValue={user?.user_metadata?.last_name || ''}
                placeholder="Votre nom"
              />
            </Field>

            <Field label="Téléphone">
              <Input
                type="tel"
                placeholder="+33 6 12 34 56 78"
              />
            </Field>

            <HStack justify="end" pt={2}>
              <Button colorPalette="brand.800">
                Enregistrer les modifications
              </Button>
            </HStack>
          </VStack>
        </Box>
      </VStack>

      {/* Security */}
      <VStack align="stretch" gap={4}>
        <Heading as="h3" fontSize="lg">
          Sécurité
        </Heading>

        <Box
          p={6}
          bg="white"
          borderRadius="lg"
          border="1px solid"
          borderColor="gray.200"
        >
          <VStack align="stretch" gap={4}>
            <HStack gap={3}>
              <Lock size={20} color="#6b7280" />
              <VStack align="start" gap={1} flex={1}>
                <Text fontWeight="medium">Mot de passe</Text>
                <Text fontSize="sm" color="gray.600">
                  Dernière modification il y a 30 jours
                </Text>
              </VStack>
              <Button variant="outline" size="sm">
                Modifier
              </Button>
            </HStack>
          </VStack>
        </Box>
      </VStack>

      {/* Coming Soon: 2FA, Sessions, etc. */}
      <Box
        p={6}
        bg="gray.50"
        borderRadius="lg"
        border="1px dashed"
        borderColor="gray.300"
        textAlign="center"
      >
        <Text color="gray.600" fontSize="sm">
          Authentification à deux facteurs et gestion des sessions à venir
        </Text>
      </Box>
    </VStack>
  )
}
